import { workflows } from '../models/common.ts'
import {
  vArray,
  vNonEmptyString,
  vObject,
  type vOutput,
  vPicklist,
  vString,
} from '../validation/index.ts'

export const productsExportSchema = vObject({
  modes: vArray(vPicklist([...workflows, 'all'])),
})
export type ProductCatalogExportDTO = vOutput<typeof productsExportSchema>

export const deleteProductsSchema = vObject({
  ids: vArray(vString()),
})
export type DeleteProductsDTO = vOutput<typeof deleteProductsSchema>

export const deleteAllProductsSchema = vObject({
  mode: vPicklist(['parcel', 'ltl', 'all']),
})
export type DeleteAllProductsDTO = vOutput<typeof deleteAllProductsSchema>

export const addCrmNoteSchema = vObject({
  note: vNonEmptyString(),
})
export type AddCrmNoteDTO = vOutput<typeof addCrmNoteSchema>
